import { useEffect, useState } from "react";

import { getCampaign } from "generated/api/campaign";

import { useCurrentCampaign } from "hooks/api/use-campaigns";
import { useCurrentClient } from "hooks/api/use-clients";

import { MondayGroupDTO } from "generated/schemas";

export const useAvailableStrategies = () => {
  const currentClient = useCurrentClient();
  const currentCampaign = useCurrentCampaign();
  const [strategies, setStrategies] = useState<MondayGroupDTO[]>([]);
  const [isLoadingStrategies, setIsLoadingStrategies] = useState(false);

  useEffect(() => {
    if (strategies.length > 0) {
      return;
    }

    const fetchStrategies = async () => {
      setIsLoadingStrategies(true);

      try {
        const campaign = getCampaign();

        const results = await campaign.getAvailableMondayStrategies({
          clientId: currentClient.id,
          id: currentCampaign.id,
        });

        setStrategies(results);
      } catch (err) {
        console.error("Failed to fetch available strategies", err);

        setStrategies([]);
      } finally {
        setIsLoadingStrategies(false);
      }
    };

    fetchStrategies();
  }, [currentCampaign.id, currentClient.id, strategies.length]);

  return { strategies, isLoadingStrategies };
};
